__webpack_require__.p = "/sg/investment/funds/";